<template>
  <v-dialog v-model="dialog">
    <v-toolbar color="primary" dark>
      <v-toolbar-title>위험운전 위치정보</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
    </v-toolbar>
    <v-sheet tile elevation="0">
      <v-container fluid class="wrapper pa-0">
        <google-map v-slot="{ google, map }" class="google-map" ref="gmap">
          <template v-for="marker in markers">
            <google-map-marker :google="google" :map="map" :marker-options="marker" :key="marker._id"></google-map-marker>
          </template>
          <google-map-control :google="google" :map="map">
            <v-btn-toggle v-model="selectedType" mandatory>
              <v-btn text value="accUp">급가속</v-btn>
              <v-btn text value="accDn">급제동</v-btn>
              <v-btn text value="accRoute">급진로변경</v-btn>
              <v-btn text value="accTurn">급회전</v-btn>
            </v-btn-toggle>
          </google-map-control>
        </google-map>
      </v-container>
    </v-sheet>
  </v-dialog>
</template>

<script>
import { getEventList } from '@/api'

export default {
  // props: {
  //   event: Object
  // },
  data () {
    return {
      event: null,
      dialog: false,
      events: [],
      selectedType: 'accUp',
      loading: false
    }
  },
  computed: {
    markers () {
      return this.events
        .filter(event => {
          return event[this.selectedType] > 0
        })
        .map(event => {
          const options = {
            _id: event._id + Date.now(),
            position: event.pos,
            labelContent: ''
          }

          if (['accUp', 'accDn'].includes(this.selectedType)) {
            options.labelContent = `${event.bspd}km/h >> ${event.spd}km/h\n`
            const diff = event.spd - event.bspd
            options.labelContent += `<br/>${diff > 0 ? `+${diff}` : diff}km/h(초)<br/>`
          }

          options.labelContent += `시간 : ${this.$moment(event.t).format('HH:mm')}`

          return options
        })
    },
    filters () {
      if (!this.event) return null
      const filters = {
        device: this.event.device,
        from: this.event.from,
        until: this.event.until
      }

      return filters
    }
  },
  methods: {
    async fetchEvents () {
      if (this.loading || !this.event) return
      this.loading = true
      try {
        const filters = this.filters
        const query = {
          fields: ''
        }

        const { events } = await getEventList(filters, query)
        this.events = events
        this.$refs.gmap.fitBounds(this.events.map(event => event.pos))
      } catch (err) {
        alert(err.message)
      }
      this.loading = false
    },
    show (device) {
      this.event = device
      this.dialog = true
      this.fetchEvents()
    }
  }
}
</script>

<style scoped>
.wrapper {
  height: 80vh
}
</style>
